module.exports = "/_next/static/images/analytics-line-e8d80e988bb48fcc1c3d58c5dbecfd02.svg";